import Reveal from '@/components/base/Reveal';
import { featuredChannels } from '@/mocks/homeData';

function FeaturedChannels() {
  return (
    <section id="featured" className="w-full bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-6xl">
          <Reveal>
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
              <div>
                <span className="inline-flex items-center gap-1.5 text-xs font-label text-accent-700 uppercase tracking-widest">
                  <i className="ri-gallery-view-2" />
                  Featured Channels
                </span>
                <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold text-foreground-950">
                  精选频道 · 大小卡混排
                </h2>
                <p className="mt-3 max-w-2xl text-sm md:text-base text-foreground-600 font-label leading-relaxed">
                  五个访问量最高的频道用大小卡混排呈现，封面驱动，一眼看清频道气质与更新活跃度。
                </p>
              </div>
              <span className="inline-flex items-center gap-1 h-9 px-3 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label whitespace-nowrap shrink-0">
                <i className="ri-eye-line" />
                按本周访问量排序
              </span>
            </div>
          </Reveal>

          <div className="mt-9 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 lg:h-[440px] lg:grid-rows-2">
            {featuredChannels.map((item, index) => (
              <Reveal
                key={item.id}
                delay={index * 60}
                className={item.big ? 'md:col-span-2 lg:col-span-2 lg:row-span-2' : ''}
              >
                <a
                  href="#subforums"
                  className={`group relative block w-full h-full min-h-[240px] lg:min-h-0 rounded-lg overflow-hidden border border-background-200 ${
                    item.big ? 'lg:min-h-full' : ''
                  }`}
                >
                  <img
                    src={item.cover}
                    alt={`${item.name} 频道封面`}
                    title={`${item.name} 频道`}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent" />
                  <div className="absolute top-4 left-4">
                    {item.big ? (
                      <span className="inline-flex items-center gap-1 h-7 px-3 rounded-full bg-primary-500 text-background-50 text-[11px] font-label">
                        <i className="ri-star-smile-line" />
                        主打频道
                      </span>
                    ) : (
                      <span className="inline-flex items-center h-7 w-7 justify-center rounded-full bg-background-50/25 text-background-50 text-xs font-label backdrop-blur">
                        {String(index + 1).padStart(2, '0')}
                      </span>
                    )}
                  </div>

                  <div className="absolute bottom-0 left-0 right-0 p-4 md:p-5">
                    <h3
                      className={`font-heading font-bold text-background-50 ${
                        item.big ? 'text-2xl md:text-3xl' : 'text-lg'
                      }`}
                    >
                      {item.name}
                    </h3>
                    <p className="mt-1 text-xs md:text-sm text-background-100/85 font-label">{item.tagline}</p>
                    {item.big && (
                      <p className="mt-2 text-xs text-accent-200 font-label">{item.meta}</p>
                    )}
                    <span className="mt-3 inline-flex items-center gap-1 text-xs font-label text-background-50 opacity-0 group-hover:opacity-100 transition-opacity">
                      进入频道
                      <i className="ri-arrow-right-line" />
                    </span>
                  </div>
                </a>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default FeaturedChannels;